<div class="spinner-container initialized">
	<div class="spinner"></div>
</div>